import React, { useState, useEffect } from 'react';

const Timer = ({ duration, onTick, onComplete, onPause, onResume, isPaused, compact = false }) => {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    setTimeLeft(duration);
  }, [duration]);

  useEffect(() => {
    if (isPaused || timeLeft <= 0) {
      if (timeLeft <= 0 && onComplete) { // Ensure onComplete is callable
        onComplete();
      }
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1;
        if (onTick) {
          onTick(newTime);
        }
        if (newTime <= 0) {
          clearInterval(intervalId);
          if (onComplete) { // Ensure onComplete is callable
            onComplete();
          }
          return 0;
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, duration, onComplete, onTick, isPaused]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const timerStyle = compact ? styles.timeDisplayCompact : styles.timeDisplay;
  const buttonStyle = compact ? styles.buttonCompact : styles.button;
  const controlsStyle = compact ? styles.controlsCompact : styles.controls;

  return (
    <div style={compact ? styles.timerContainerCompact : styles.timerContainer}>
      <div style={timerStyle}>{formatTime(timeLeft)}</div>
      {!compact && (
          <div style={controlsStyle}>
            {isPaused ? (
              <button onClick={onResume} style={{...buttonStyle, ...styles.resumeButton}}>
                Resume
              </button>
            ) : (
              <button onClick={onPause} style={{...buttonStyle, ...styles.pauseButton}}>
                Pause
              </button>
            )}
          </div>
      )}
      {/* In compact mode, pause/resume is handled by the main workout screen's overall timer pause button if needed */}
      {/* Or, if individual pause for compact timers is desired, a smaller button could be added here. */}
      {/* For now, the main pause button controls all timers via the isPaused prop. */}
    </div>
  );
};

const styles = {
  timerContainer: {
    textAlign: 'center',
    margin: '20px 0',
  },
  timeDisplay: {
    fontSize: '3.5em',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#f0f0f0',
    borderRadius: '10px',
    display: 'inline-block',
    minWidth: '180px',
  },
  controls: {
    marginTop: '10px',
  },
  button: {
    padding: '12px 25px',
    fontSize: '1.1em',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
    transition: 'background-color 0.2s ease',
  },
  // Compact styles
  timerContainerCompact: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Center if no controls
    margin: '5px 0',
  },
  timeDisplayCompact: {
    fontSize: '1.2em', // Significantly smaller
    fontWeight: 'bold',
    color: '#007bff',
    padding: '3px 8px',
    backgroundColor: 'transparent', // Or a very light one
    borderRadius: '5px',
    minWidth: '60px', // Smaller min-width
    textAlign: 'center',
  },
  controlsCompact: { // Not used if buttons are hidden for compact
    marginLeft: '10px',
  },
  buttonCompact: {
    padding: '4px 8px',
    fontSize: '0.8em',
    borderRadius: '4px',
  },
  pauseButton: {
    backgroundColor: '#ffc107', // Amber
    color: '#333',
  },
  resumeButton: {
    backgroundColor: '#28a745', // Green
    color: 'white',
  },
};

export default Timer; 